import React, { useState } from 'react';
import Modal from '../../../../components/Modal/Modal';
import NotAvailableModal from '@/presentation/modules/procedures/components/Modals/NotAvailable';
import Spinner from '@/presentation/components/Spinner';
import ProcedureHeader from '@/presentation/modules/procedures/components/ContainerProcedure/Header';
import ModuleContainer from '@/presentation/components/Container';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';
import ErrorMessage from '@/presentation/components/Error';
import ReusableButton from '@/presentation/reusables/Button';
import InfoComponent from './components/InfoComponent';
import ModalWrapper from './components/ModalWrapper';
import MyModal from '@/presentation/modules/procedures/components/Modals/MyModal';

interface GraduatedInfoProps {
  onBackButton: () => void;
  procedureSelectedInfo: any;
  errorInfo?: any;
  handleExistRequest: () => void;
  disabled: {
    showNotAvailableModal: boolean;
    setShowNotAvailableModal: (value: boolean) => void;
  };
  error: {
    defaultErrorModal: boolean;
    setDefaultErrorModal: (value: boolean) => void;
  };
}

const GraduatedCertificateView: React.FC<GraduatedInfoProps> = ({
  onBackButton,
  procedureSelectedInfo,
  errorInfo,
  handleExistRequest,
  disabled,
  error
}) => {
  const [showModel, setShowModel] = useState(false);
  const { showNotAvailableModal, setShowNotAvailableModal } = disabled;
  const { defaultErrorModal, setDefaultErrorModal } = error;

  const renderLoadingOrError = () => {
    if (!procedureSelectedInfo) {
      return <Spinner />;
    }
    if (!procedureSelectedInfo || errorInfo) {
      return <ErrorMessage />;
    }
    return null;
  };
  return (
    <>
      <ModuleContainer containerType="subsection">
        <SubsectionHeader
          title="Certificado de egresado"
          onClick={onBackButton}
        />
        {renderLoadingOrError()}
        {procedureSelectedInfo && (
          <>
            <ProcedureHeader
              amount={procedureSelectedInfo.amount}
              duration={procedureSelectedInfo.duration}
              date={procedureSelectedInfo.endDate}
              paddingData={12}
              paddingBottomData={16}
            />
            <InfoComponent
              setShowModel={() => setShowModel(!showModel)}
              steps={procedureSelectedInfo.stepsToFollow}
            />
            <div style={{ paddingTop: 24 }}>
              <ReusableButton onClick={handleExistRequest}>
                Empezar validación
              </ReusableButton>
            </div>
          </>
        )}
        {showModel && (
          <ModalWrapper
            onClose={() => setShowModel(!showModel)}
            isOpen
            name="Modelo de constancia de egresado"
          />
        )}
      </ModuleContainer>
      <Modal
        show={showNotAvailableModal}
        handleClose={() => setShowNotAvailableModal(false)}
      >
        <NotAvailableModal handleClick={onBackButton} />
      </Modal>
      <MyModal
        show={defaultErrorModal}
        data={{
          title: `${procedureSelectedInfo?.error?.title}`,
          description: `${procedureSelectedInfo?.error?.description}`
        }}
        handlerClick={onBackButton}
        handlerClose={() => {
          setDefaultErrorModal(false);
        }}
      />
    </>
  );
};

export default GraduatedCertificateView;
